<template>
  <ul :class="'list-unstyled p-0 m-0 chat-box ' + (reply_message?'chat-box-with-reply':'')" v-chat-scroll="{always: false, smooth: true}">
<!--    <li :class="(message.to_speaker?'message-to-speaker':'')+' p-1 border rounded '" v-for="(message, index) in room.messages" :key="message.id" :style="'background:'+client_settings.messages_background+';border-color:'+client_settings.messages_border_color" :title="message.status">-->
    <one-message v-for="(message, index) in room.messages" :message="message" :index="index" :key="message.id" :room_language="room.language" :client_settings="client_settings" :user="user" :text_lang="text_lang" :reply_message="reply_message" :PMReady="PMReady" v-on:send-set-reply="sendSetReply($event)" v-on:send-context-menu="sendContextMenu($event)" v-on:send-pm-user="sendPMUser($event)"></one-message>
  </ul>
</template>

<script>
import OneMessage from "./OneMessage";

export default {
    name: 'MessagesList',
    components: {
        OneMessage
    },
    props: {
        room: null,
        user: null,
        reply_message: null,
        PMReady: null,
        client_settings: {},
        text_lang: {}
    },
    methods: {
        sendSetReply(reply) {
            this.$emit('setReply', reply);
        },
        sendContextMenu(obj) {
            console.log('SendContextMenu')
            console.log(obj)
            this.$emit('rightMenuOpen', obj);
        },
        sendPMUser(user) {
            this.$emit('setPrivateMessageTo', user);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
